/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIAssistRequest } from '../models/AIAssistRequest';
import type { AIAssistResponse } from '../models/AIAssistResponse';
import type { ChartDataResponse } from '../models/ChartDataResponse';
import type { CompaniesByFirm } from '../models/CompaniesByFirm';
import type { CreateFirmRequests } from '../models/CreateFirmRequests';
import type { ExtendedCompanyInfo } from '../models/ExtendedCompanyInfo';
import type { Firm } from '../models/Firm';
import type { FirmCompanies } from '../models/FirmCompanies';
import type { FirmCompaniesRequestsProgress } from '../models/FirmCompaniesRequestsProgress';
import type { FirmCompany } from '../models/FirmCompany';
import type { FirmRequestedDocumentModel } from '../models/FirmRequestedDocumentModel';
import type { FirmRequestsView } from '../models/FirmRequestsView';
import type { FirmStepper } from '../models/FirmStepper';
import type { FirmSummaryDefinition } from '../models/FirmSummaryDefinition';
import type { FirmSummaryRead } from '../models/FirmSummaryRead';
import type { FirmUserPermission } from '../models/FirmUserPermission';
import type { FundByMeasurementDate } from '../models/FundByMeasurementDate';
import type { FundName } from '../models/FundName';
import type { InvestmentCompanyInfo } from '../models/InvestmentCompanyInfo';
import type { SummaryDataResponse } from '../models/SummaryDataResponse';
import type { SummaryDefinitionOrder } from '../models/SummaryDefinitionOrder';
import type { UpdateFirmQuestion } from '../models/UpdateFirmQuestion';
import type { UserFirmRole } from '../models/UserFirmRole';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FirmsService {
  /**
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsList(
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmUserPermission>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms',
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param data
   * @returns FirmCompany
   * @throws ApiError
   */
  public static apiFirmsCompaniesNewCreate(
    data: FirmCompany,
  ): CancelablePromise<FirmCompany> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/companies/new',
      body: data,
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsCreateFirmQuestionCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/create-firm-question',
    });
  }
  /**
   * @param data
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsCreateFirmRequestedDocumentCreate(
    data: FirmRequestedDocumentModel,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/create-firm-requested-document',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CreateFirmRequests
   * @throws ApiError
   */
  public static apiFirmsCreateRequestsCreate(
    data: CreateFirmRequests,
  ): CancelablePromise<CreateFirmRequests> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/create-requests',
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentRead(
    requestedDocumentId: string,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
    });
  }
  /**
   * @param requestedDocumentId
   * @param data
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentUpdate(
    requestedDocumentId: string,
    data: FirmRequestedDocumentModel,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @param data
   * @returns FirmRequestedDocumentModel
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentPartialUpdate(
    requestedDocumentId: string,
    data: FirmRequestedDocumentModel,
  ): CancelablePromise<FirmRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsFirmRequestedDocumentDelete(
    requestedDocumentId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/firm-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
    });
  }
  /**
   * @param data
   * @returns FirmStepper
   * @throws ApiError
   */
  public static apiFirmsNewCreate(
    data: FirmStepper,
  ): CancelablePromise<FirmStepper> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/new',
      body: data,
    });
  }
  /**
   * @param questionId
   * @returns UpdateFirmQuestion
   * @throws ApiError
   */
  public static apiFirmsQuestionRead(
    questionId: string,
  ): CancelablePromise<UpdateFirmQuestion> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
    });
  }
  /**
   * @param questionId
   * @param data
   * @returns UpdateFirmQuestion
   * @throws ApiError
   */
  public static apiFirmsQuestionUpdate(
    questionId: string,
    data: UpdateFirmQuestion,
  ): CancelablePromise<UpdateFirmQuestion> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
      body: data,
    });
  }
  /**
   * @param questionId
   * @param data
   * @returns UpdateFirmQuestion
   * @throws ApiError
   */
  public static apiFirmsQuestionPartialUpdate(
    questionId: string,
    data: UpdateFirmQuestion,
  ): CancelablePromise<UpdateFirmQuestion> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
      body: data,
    });
  }
  /**
   * @param questionId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsQuestionDelete(
    questionId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/question/{question_id}',
      path: {
        'question_id': questionId,
      },
    });
  }
  /**
   * @param firmId
   * @param fileType
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsAssetSignedUrlRead(
    firmId: string,
    fileType: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/asset-signed-url/{file_type}',
      path: {
        'firm_id': firmId,
        'file_type': fileType,
      },
    });
  }
  /**
   * @param firmId
   * @param companyId
   * @returns InvestmentCompanyInfo
   * @throws ApiError
   */
  public static apiFirmsFundInvestmentRead(
    firmId: string,
    companyId: string,
  ): CancelablePromise<InvestmentCompanyInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/fund-investment/{company_id}',
      path: {
        'firm_id': firmId,
        'company_id': companyId,
      },
    });
  }
  /**
   * @param firmId
   * @returns FirmRequestsView
   * @throws ApiError
   */
  public static apiFirmsQuestionsAndRequestedDocumentsRead(
    firmId: string,
  ): CancelablePromise<FirmRequestsView> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/questions-and-requested-documents',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param firmId
   * @returns FirmCompaniesRequestsProgress
   * @throws ApiError
   */
  public static apiFirmsRequestsProgressRead(
    firmId: string,
  ): CancelablePromise<FirmCompaniesRequestsProgress> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_id}/requests-progress',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param firmPk
   * @param page A page number within the paginated result set.
   * @returns CompaniesByFirm A list of CompaniesByFirm objects
   * @throws ApiError
   */
  public static apiFirmsCompaniesListList(
    firmPk: string,
    page?: number,
  ): CancelablePromise<Array<CompaniesByFirm>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{firm_pk}/companies-list/',
      path: {
        'firm_pk': firmPk,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param firmPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersUpdate(
    firmPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_pk}/users',
      path: {
        'firm_pk': firmPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersPartialUpdate(
    firmPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{firm_pk}/users',
      path: {
        'firm_pk': firmPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersUpdate1(
    firmPk: string,
    userPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_pk}/users/{user_pk}',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUsersPartialUpdate1(
    firmPk: string,
    userPk: string,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{firm_pk}/users/{user_pk}',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsUsersDelete(
    firmPk: string,
    userPk: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/{firm_pk}/users/{user_pk}',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns UserFirmRole
   * @throws ApiError
   */
  public static apiFirmsUsersRolesUpdate(
    firmPk: string,
    userPk: string,
    data: UserFirmRole,
  ): CancelablePromise<UserFirmRole> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param firmPk
   * @param userPk
   * @param data
   * @returns UserFirmRole
   * @throws ApiError
   */
  public static apiFirmsUsersRolesPartialUpdate(
    firmPk: string,
    userPk: string,
    data: UserFirmRole,
  ): CancelablePromise<UserFirmRole> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
      path: {
        'firm_pk': firmPk,
        'user_pk': userPk,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this firm.
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsRead(
    id: number,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this firm.
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsUpdate(
    id: number,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this firm.
   * @param data
   * @returns Firm
   * @throws ApiError
   */
  public static apiFirmsPartialUpdate(
    id: number,
    data: Firm,
  ): CancelablePromise<Firm> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsCompaniesList(
    id: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmCompanies>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/companies',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param cId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsCompanyRead(
    id: string,
    cId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ExtendedCompanyInfo>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/company/{c_id}',
      path: {
        'id': id,
        'c_id': cId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this fund.
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsFundsList(
    id: number,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FundName>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/funds',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsGenerationJobsBulkCreate(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/generation-jobs/bulk',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsHasSummaryRead(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/has-summary',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns any Indicates if the firm has summary data
   * @throws ApiError
   */
  public static apiFirmsHasSummaryCreate(
    id: string,
    data: FundByMeasurementDate,
  ): CancelablePromise<{
    has_summary?: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/has-summary',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param date Optional date filter in YYYY-MM-DD format
   * @param fundId Optional fund ID filter
   * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
   * @returns FirmSummaryRead
   * @throws ApiError
   */
  public static apiFirmsSummaryRead(
    id: string,
    date?: string,
    fundId?: number,
    breakevenMultiple?: string,
  ): CancelablePromise<FirmSummaryRead> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary',
      path: {
        'id': id,
      },
      query: {
        'date': date,
        'fund_id': fundId,
        'breakeven_multiple': breakevenMultiple,
      },
      errors: {
        400: `Invalid date format`,
      },
    });
  }
  /**
   * @param id
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsList(
    id: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmSummaryDefinition>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsCreate(
    id: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/summary-definitions',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * Translate a natural-language prompt into a SpreadsheetDefinition update.
   * @param id
   * @param data
   * @returns AIAssistResponse
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsAiAssistCreate(
    id: string,
    data: AIAssistRequest,
  ): CancelablePromise<AIAssistResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/firms/{id}/summary-definitions/ai-assist',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Invalid request`,
        503: `AI service unavailable`,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns SummaryDefinitionOrder
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsOrderUpdate(
    id: string,
    data: SummaryDefinitionOrder,
  ): CancelablePromise<SummaryDefinitionOrder> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}/summary-definitions/order',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns SummaryDefinitionOrder
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsOrderPartialUpdate(
    id: string,
    data: SummaryDefinitionOrder,
  ): CancelablePromise<SummaryDefinitionOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}/summary-definitions/order',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsRead(
    id: string,
    definitionId: string,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsUpdate(
    id: string,
    definitionId: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @param data
   * @returns FirmSummaryDefinition
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsPartialUpdate(
    id: string,
    definitionId: string,
    data: FirmSummaryDefinition,
  ): CancelablePromise<FirmSummaryDefinition> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param definitionId
   * @returns void
   * @throws ApiError
   */
  public static apiFirmsSummaryDefinitionsDelete(
    id: string,
    definitionId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/firms/{id}/summary-definitions/{definition_id}',
      path: {
        'id': id,
        'definition_id': definitionId,
      },
    });
  }
  /**
   * Return trending data for all numeric metrics in the definition
   * across all measurement dates.
   * Response shape:
   * {
     * "measurement_dates": ["2024-03-31", ...],
     * "entities": {
       * "<entity_name>": {
         * "<metric>": [value_or_null, ...]
         * }
         * }
         * }
         *
         * Value arrays are positionally aligned with measurement_dates.
         * @param id
         * @param definitionId
         * @returns ChartDataResponse
         * @throws ApiError
         */
        public static apiFirmsSummaryDefinitionsChartDataRead(
          id: string,
          definitionId: string,
        ): CancelablePromise<ChartDataResponse> {
          return __request(OpenAPI, {
            method: 'GET',
            url: '/api/firms/{id}/summary-definitions/{definition_id}/chart-data',
            path: {
              'id': id,
              'definition_id': definitionId,
            },
            errors: {
              400: `Invalid request`,
            },
          });
        }
        /**
         * Return snapshot data for a summary definition.
         * Query params:
         * measurement_date (date, optional): YYYY-MM-DD or MM/DD/YYYY.
         * If omitted, returns each company's latest available snapshot.
         *
         * Response shape:
         * {
           * "rows": [
             * {
               * "id": 123,
               * "<column_type>": <value>,
               * ...
               * }
               * ]
               * }
               *
               * Row keys correspond to the column types stored in
               * spreadsheet_definition.columns. See COLUMN_TO_BUCKET in
               * column_mapping.py for all supported column types and their
               * data sources on LookingGlassSnapshot.
               * @param id
               * @param definitionId
               * @param measurementDate
               * @returns SummaryDataResponse
               * @throws ApiError
               */
              public static apiFirmsSummaryDefinitionsDataRead(
                id: string,
                definitionId: string,
                measurementDate?: string,
              ): CancelablePromise<SummaryDataResponse> {
                return __request(OpenAPI, {
                  method: 'GET',
                  url: '/api/firms/{id}/summary-definitions/{definition_id}/data',
                  path: {
                    'id': id,
                    'definition_id': definitionId,
                  },
                  query: {
                    'measurement_date': measurementDate,
                  },
                  errors: {
                    400: `Invalid measurement date or filter type mismatch`,
                  },
                });
              }
            }
